const consumers = {};

/**
 * A simple messages broker for annotations fields loading view
 */
const remainingPrintsListener = {
  /**
   * Register a function to run when a message is published to this channel
   * @param {string} source
   * @param {function(number)} listener listen to value of remaining report prints events
   */
  subscribe(source, listener) {
    consumers[source] = listener;
  },

  /**
   * Publish a message to this channel
   * @param {number} message
   */
  publish(message) {
    Object.keys(consumers).forEach(source => {
      const listen = consumers[source];
      listen(message);
    });
  }
};

export default remainingPrintsListener;
